export const MODAL_DIALOG__CHANGE_PASSWORD = 'MODAL_DIALOG__CHANGE_PASSWORD';
export const MODAL_DIALOG__DELETE_ACCOUNT = 'MODAL_DIALOG__DELETE_ACCOUNT';
